// src/components/Auth/ProtectedRoute.jsx
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectHasClientAccess,
  selectClientAccess,
} from "../../store/authSlice";

// Demo clients accessible without authentication
const DEMO_SLUGS = ["sample-laundry-co", "sample-catering-co"];

/**
 * Protected route wrapper
 * Redirects to login if not authenticated.
 * Redirects to the user's first accessible client if they lack access
 * to the requested client.
 */
const ProtectedRoute = ({ children }) => {
  const { clientSlug } = useParams();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasAccess = useSelector((state) =>
    clientSlug ? selectHasClientAccess(state, clientSlug) : true,
  );
  const clientAccess = useSelector(selectClientAccess);

  // Demo clients are publicly accessible
  if (clientSlug && DEMO_SLUGS.includes(clientSlug)) {
    return children;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (clientSlug && !hasAccess) {
    // Redirect to the user's first accessible client instead of
    // showing an Access Denied page that loops back to login.
    if (clientAccess.length > 0) {
      return <Navigate to={`/${clientAccess[0]}`} replace />;
    }

    // No accessible clients at all
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
